export default "__VITE_ASSET__CJtIkL8S__"